import "./UploadeFile.scss";
import { useState } from "react";

const UploadFile = ({ grid, urlImage, sizeImage, dataType }) => {
    const [image, setImage] = useState(
        "https://teamhulo.github.io/img-slicer/placeholder.png"
    );
    const [imageUrl, setImageUrl] = useState();
    const fileReader = new FileReader();
    const showGrid =
        dataType == "grid" ? (
            <div
                className="gallery-div"
                style={{ backgroundSize: `${grid}% ${grid}%` }}
            ></div>
        ) : (
            <div
                className="gallery-div"
                style={{ backgroundSize: `${grid}% 100%` }}
            ></div>
        );
    fileReader.onloadend = () => {
        setImageUrl(fileReader.result);
        urlImage(fileReader.result);
        let image = new Image();
        image.src = fileReader.result;
        image.onload = function () {
            sizeImage({ w: this.width, h: this.height });
        };
    };

    const onChangeHandler = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        setImage(file);
        if (file != null || file != undefined) {
            fileReader.readAsDataURL(file);
        }
    };

    return (
        <div className="form-wrapper">
            <form className="uploade">
                <p>Drop your image here or click below to upload.</p>
                <div className="uploade-img-wrap">
                    <img src={imageUrl ? imageUrl : image} alt="#" />
                    {imageUrl && showGrid}
                </div>
                <input
                    type="file"
                    id="upload-file"
                    onChange={onChangeHandler}
                />
                <button className="choose-btn btn">Choose File</button>
            </form>
        </div>
    );
};

export default UploadFile;
